<template>
  <b-form @submit.prevent="saveData" ref="form" autocomplete="off">
    <b-row class="mb-3">
      <b-col lg="12" md="12" sm="12">
        <div class="label_input text_red">* Campos requeridos.</div>
      </b-col>
      <b-col lg="6" md="6" sm="12" class="mb-3">
        <div role="group">
          <label for="name" class="label_input">Nombre<span class="text_red">*</span></label>
          <b-form-input
            id="name"
            size="sm"
            placeholder="Nombre"
            v-model="formData.name"
            :disabled="isDisable"
            autofocus
          />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" class="mb-3">
        <div role="group">
          <label for="nit" class="label_input">NIT</label>
          <b-form-input
            id="nit"
            size="sm"
            type="number"
            placeholder="NIT"
            v-model="formData.nit"
            :disabled="isDisable"
            autofocus
          />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" class="mb-3">
        <div role="group">
          <label for="address" class="label_input">Dirección</label>
          <b-form-input
            id="address"
            size="sm"
            placeholder="Dirección"
            v-model="formData.address"
            :disabled="isDisable"
            autofocus
          />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" class="mb-3">
        <div role="group">
          <label for="phone" class="label_input">Teléfono</label>
          <b-form-input
            id="phone"
            type="number"
            size="sm"
            placeholder="Teléfono"
            v-model="formData.phone"
            :disabled="isDisable"
            autofocus
          />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" class="mb-3">
        <div role="group">
          <label for="email" class="label_input">Correo electrónico</label>
          <b-form-input
            id="email"
            type="email"
            size="sm"
            placeholder="Correo electrónico"
            v-model="formData.email"
            :disabled="isDisable"
            autofocus
          />
        </div>
      </b-col>
    </b-row>
    <b-row class="footer-modal-customer" v-if="!isDisable">
      <b-col cols="12" class="d-flex justify-content-end">
        <b-button
          type="submit"
          size="lg"
          class="btn btn-success w-width"
          :disabled="isBusy || $v.$invalid"
        >
          <b-spinner class="mr-2" v-if="isBusy" small />
          Guardar
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BCol,
  BRow,
  BButton,
  BForm,
  BSpinner,
  BFormInput,
} from "bootstrap-vue";
import { required } from "vuelidate/lib/validators";
import ActionCRUD from "@/mixins/ActionCRUD";

export default {
  inject: ["supplierRepository"],
  components: {
    BCol,
    BRow,
    BButton,
    BForm,
    BFormInput,
    BSpinner,
  },
  mixins: [ActionCRUD],
  props: {
    record: {
      type: Object,
      default: null,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isBusy: false,
      formData: {
        name: '',
        nit: '',
        email: '',
        phone: '',
        address: '',
      },
      repository: "supplierRepository",
    };
  },
  validations: {
    formData: {
      name: {
        required,
      },
    },
  },
  async mounted() {
    const me = this;
    if (me.record) {
      me.formData = { ...me.formData, ...me.record };
      delete me.formData.enterpriseUuid;
      delete me.formData.status;
    }
  },
};
</script>

<style></style>
